import { render, staticRenderFns } from "./CusChatCommon.vue?vue&type=template&id=4905c5d5&scoped=true&"
import script from "./CusChatCommon.vue?vue&type=script&lang=js&"
export * from "./CusChatCommon.vue?vue&type=script&lang=js&"
import style0 from "./CusChatCommon.vue?vue&type=style&index=0&id=4905c5d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4905c5d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4905c5d5')) {
      api.createRecord('4905c5d5', component.options)
    } else {
      api.reload('4905c5d5', component.options)
    }
    module.hot.accept("./CusChatCommon.vue?vue&type=template&id=4905c5d5&scoped=true&", function () {
      api.rerender('4905c5d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group/components/CusChatCommon.vue"
export default component.exports